import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import styled from '@emotion/styled';

const PreloaderContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#ffffff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
  transition: 'opacity 0.5s ease, visibility 0.5s ease',
  opacity: 1,
  visibility: 'visible',
  '&.loaded': {
    opacity: 0,
    visibility: 'hidden',
  }
}));

const SpinnerContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '60px',
  height: '60px',
}));

const Spinner = styled(Box)(({ theme }) => ({
  position: 'absolute',
  border: '4px solid #f3f3f3',
  borderTop: `4px solid ${theme.palette.primary.main}`,
  borderRadius: '50%',
  width: '60px',
  height: '60px',
  animation: 'spin 1s linear infinite',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

function Preloader() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Simulate loading time and then hide the preloader
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <PreloaderContainer className={loaded ? 'loaded' : ''}>
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    </PreloaderContainer>
  );
}

export default Preloader;
